<template>
  <div class="wrapper-double-content">
    <div class="row flex-grow-1">
      <div class="col d-flex flex-grow-1">
        <main class="wrapper-double-content--main-wrapper-content">
          <Breadcrumb/>
          <slot>
            <ifac-loader style="height: 110px"/>
          </slot>
        </main>
        <ifac-collapsible-side-panel
          v-if="tabs?.length > 0"
          :iconList="tabs"
          @icon-click="handleIconClick"
          :headerText="activeComponent.headerText"
        >
          <keep-alive>
            <component :is="activeComponent.component" v-bind="activeComponent.options"/>
          </keep-alive>
        </ifac-collapsible-side-panel>
      </div>
    </div>
  </div>
</template>
<script>
import { IfacCollapsibleSidePanel, IfacLoader } from '@ifac/ui';
import Breadcrumb from '@/views/components/portals/partials/Breadcrumb.vue';
import { mapMutations, mapState } from 'vuex';

export default {
  components: {
    IfacLoader,
    IfacCollapsibleSidePanel,
    Breadcrumb,
  },
  props: {
    tabs: Array,
  },
  data() {
    return {
      tabIndex: 0,
    };
  },
  methods: {
    ...mapMutations({
      toggleSidePanelCollapse: 'uiHelpers/toggleSidePanelCollapse',
    }),
    handleIconClick(index) {
      if (this.sidePanelIsCollapsed) {
        this.toggleSidePanelCollapse();
      }

      this.tabIndex = index;
    },
  },
  computed: {
    ...mapState({
      sidePanelIsCollapsed: (state) => state.uiHelpers.sidePanelIsCollapsed,
    }),
    activeComponent() {
      return this.tabs[this.tabIndex];
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/base/_variables.scss";
@import "@/assets/styles/base/_mixins.scss";

.wrapper-double-content {
  display: flex;
  position: relative;
  padding: 0;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
  margin-left: auto;
  margin-right: auto;

  &--main-wrapper-content {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding-left: 0;
    padding-right: 0;

    .main-content {
      @include media(tablet) {
        padding-right: 2.5rem;
      }
    }
  }
}

.portal-content {
  &--bread-crumbs {
    margin-bottom: 0;
  }
}
</style>
